// extracted by mini-css-extract-plugin
module.exports = {"modifyBlockContainer":"WallBaseBlock_modifyBlockContainer__1fKUm","modifyBlockImg":"WallBaseBlock_modifyBlockImg__3OwMG","paymentBlockImg":"WallBaseBlock_paymentBlockImg__2sf4V"};